import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import { PATHS } from "utils/consts";
import AddBankV2 from "./AddBankV2";
import ConfirmOrderV2 from "./ConfirmOrderV2";
import EnterWalletAddressV2 from "./EnterWalletAddressV2";
import PaymentMethod from "./PaymentMethod";
import BankCard from "./BankCard";
import BankCardAuthentication from "./BankCardAuthentication";
import NewCard from "./NewCard";
import BillingAddressV2 from "./BillingAddressV2";

export const Sell: React.FC = () => {
  const location = useLocation();

  return (
    <>
      <Outlet />
      <Routes location={location}>
        <Route path={PATHS.BANK_DETAIL} element={<AddBankV2 />}></Route>
        <Route path={PATHS.WALLET_ADDRESS} element={<EnterWalletAddressV2 />} />
        <Route path={PATHS.CONFRIM_ORDER} element={<ConfirmOrderV2 />}></Route>
        <Route path={PATHS.PAYMENT_METHOD} element={<PaymentMethod />}></Route>
        <Route path={PATHS.BANKCARD} element={<BankCard />}></Route>
        <Route path={PATHS.BANKCARD_AUTHENTICATION} element={<BankCardAuthentication />}></Route>
        <Route path={PATHS.NEWCARD} element={<NewCard />}></Route>
        <Route path={PATHS.BILLING_ADDRESS} element={<BillingAddressV2 />}></Route>
      </Routes>
    </>
  );
};